import React from "react";

export default function DocumentIntro({ state }) {
  const formatDate = (date) => {
    if (!date) return new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    return new Date(date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      {/* Company Header */}
      <div style={{ marginBottom: '8px' }}>
        {/* <h2 style={{
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#0f172a',
          margin: 0,
          marginBottom: '2px'
        }}>
          {state.companyName || "DALOCAL TECHNOLOGIES PRIVATE LIMITED"}
        </h2> */}
        {state.companyEmail && (
          <p style={{
            fontSize: '11px',
            color: '#475569',
            margin: 0
          }}>
            {state.companyEmail}
          </p>
        )}
      </div>

      {/* Date Section */}
      <div style={{ marginBottom: '16px' }}>
        <p style={{
          fontSize: '11px',
          color: '#475569',
          margin: 0,
          fontWeight: '500'
        }}>
          Date: {formatDate(state?.created_at || state?.createdAt)}
        </p>
        {state?.sent_at && (
          <p style={{
            fontSize: '11px',
            color: '#475569',
            margin: '2px 0 0 0'
          }}>
            Sent Date: {new Date(state.sent_at).toLocaleString("en-US", { 
              year: "numeric", 
              month: "short", 
              day: "numeric", 
              hour: "2-digit", 
              minute: "2-digit" 
            })}
          </p>
        )}
      </div>
      
      {/* Recipient Section */}
      <div style={{ marginBottom: '12px' }}>
        <p style={{
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#0f172a',
          margin: 0,
          marginBottom: '4px'
        }}>
         {state.recipientName || "[RECIPIENT NAME]"}
        </p>
        {state.recipientAddress && (
          <p style={{
            fontSize: '10px',
            color: '#475569',
            margin: 0,
            whiteSpace: 'pre-line',
            lineHeight: 1.3
          }}>
            {state.recipientAddress}
          </p>
        )}
      </div>
      
      {/* Recipient Email with comma */}
      {state.recipientEmail && (
        <p style={{
          fontSize: '11px',
          color: '#0f172a',
          margin: 0,
          marginBottom: '12px',
          fontWeight: '500'
        }}>
          {state.recipientEmail},
        </p>
      )}
      
      {/* Subject Section */}
      {state.subject && (
        <div style={{ marginBottom: '12px' }}>
          <p style={{
            fontSize: '12px',
            fontWeight: 'bold',
            color: '#0f172a',
            margin: 0,
            textDecoration: 'underline',
            textUnderlineOffset: '3px'
          }}>
            Subject: {state.subject}
          </p>
        </div>
      )}
      
      {/* Salutation */}
      <p style={{
        fontSize: '11px',
        color: '#0f172a',
        margin: 0,
        marginBottom: '16px',
        fontWeight: '500'
      }}>
        Dear {state.recipientName || "Sir/Madam"},
      </p>
    </div>
  );
}